import React from 'react';
import {
  YouTube as YouTubeIcon,
  Instagram as InstagramIcon,
  Twitter as TwitterIcon,
  Reddit as RedditIcon,
  LinkedIn as LinkedInIcon,
  Facebook as FacebookIcon,
} from '@mui/icons-material';

export const PLATFORM_CONFIG = {
  youtube: {
    label: 'YouTube',
    color: '#ff0000',
    gradient: 'linear-gradient(135deg, #ff0000, #ff4444)',
    description: 'Video & Shorts',
    requiredFields: ['title'],
    isMediaRequired: true,
    mediaLabel: 'Video file (required for YouTube)',
    mediaAccept: 'video/*',
    schedulingSupported: true,
  },
  instagram: {
    label: 'Instagram',
    color: '#e1306c',
    gradient: 'linear-gradient(135deg, #e1306c, #f56040)',
    description: 'Posts & Reels',
    requiredFields: [],
    isMediaRequired: true,
    mediaLabel: 'Image or video file',
    mediaAccept: 'image/*,video/*',
    schedulingSupported: true,
  },
  facebook: {
    label: 'Facebook',
    color: '#1877f2',
    gradient: 'linear-gradient(135deg, #1877f2, #42a5f5)',
    description: 'Posts & Videos',
    requiredFields: [],
    isMediaRequired: false,
    mediaLabel: 'Image or video (optional)',
    mediaAccept: 'image/*,video/*',
    schedulingSupported: false,
  },
  twitter: {
    label: 'Twitter / X',
    color: '#1da1f2',
    gradient: 'linear-gradient(135deg, #1da1f2, #42a5f5)',
    description: 'Micro-blogging',
    requiredFields: ['text'],
    isMediaRequired: false,
    mediaLabel: 'Image or video (optional)',
    mediaAccept: 'image/*,video/*',
    schedulingSupported: true,
  },
  linkedin: {
    label: 'LinkedIn',
    color: '#0a66c2',
    gradient: 'linear-gradient(135deg, #0a66c2, #0d8fd6)',
    description: 'Professional network',
    requiredFields: [],
    isMediaRequired: false,
    mediaLabel: 'Image (optional)',
    mediaAccept: 'image/*,video/*',
    schedulingSupported: false,
  },
  reddit: {
    label: 'Reddit',
    color: '#ff4500',
    gradient: 'linear-gradient(135deg, #ff4500, #ff6b35)',
    description: 'Discussion forum',
    requiredFields: ['title', 'subreddit'],
    isMediaRequired: false,
    mediaLabel: 'Image or video (optional)',
    mediaAccept: 'image/*,video/*',
    schedulingSupported: false,
  },
};

// Icons are JSX so kept separate to avoid re-creating on every import
export const PLATFORM_ICONS = {
  youtube: <YouTubeIcon />,
  instagram: <InstagramIcon />,
  facebook: <FacebookIcon />,
  twitter: <TwitterIcon />,
  linkedin: <LinkedInIcon />,
  reddit: <RedditIcon />,
};

export const PLATFORM_LIST = Object.entries(PLATFORM_CONFIG).map(([value, meta]) => ({
  value,
  ...meta,
  icon: PLATFORM_ICONS[value],
}));
